import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/login/:usuario?/:password?',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('./views/Users.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/busqueda',
            name: 'busqueda',
            component: () => import('./views/Busqueda.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/languages',
            name: 'languages',
            component: () => import('./views/Languages.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/questionnaires',
            name: 'questionnaires',
            component: () => import('./views/Questionnaires.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/surveys',
            name: 'surveys',
            component: () => import('./views/Surveys.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/usersurvey',
            name: 'usersurvey',
            component: () => import('./views/UserSurvey.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/newsurvey',
            name: 'newsurvey',
            component: () => import('./views/NewSurvey.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/surveyresults',
            name: 'surveyresults',
            component: () => import('./views/SurveyResults.vue'),
            meta: {
                authRequired: true
            }
        },
        { path: '/redirect-me', redirect: { name: 'home' } },
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.idToken) {
            next({
                path: '/'
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
